// Components
import { Button, Link, Image } from '@tracklib/kit'

// Hooks
import { useDarkMode } from 'modules/profile/hooks'

import styles from './featuredbuttonblock.css'

const handleClick = (url: string) => {
  const browserWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  if (url === '?modal=signup' && browserWidth < 769) {
    return window.scrollTo(0, 0)
  }
  return null
}

type FeaturedButtonBlockProps = {
  value: {
    image: number
    image_background_color: string
    image_background_color_dark_mode: string
    text_color: string
    text_color_dark_mode: string
    heading: string
    subtext: string
    button_text: string
    button_url: string
    show_skip_button: boolean
    skip_button_text: string
    skip_button_url: string
  }
}

const FeaturedButtonBlock = ({
  value: {
    image,
    image_background_color,
    image_background_color_dark_mode,
    text_color,
    text_color_dark_mode,
    heading,
    subtext,
    button_text,
    button_url,
    show_skip_button,
    skip_button_text,
    skip_button_url,
  },
}: FeaturedButtonBlockProps): JSX.Element => {
  const isDarkMode = useDarkMode()
  const isExternalButton = button_url.startsWith('http') || button_url.startsWith('www')
  const isExternalSkipButton = skip_button_url.startsWith('http') || skip_button_url.startsWith('www')

  return (
    <div
      className={styles.wrapper}
      style={{
        backgroundColor:
          isDarkMode && image_background_color_dark_mode ? image_background_color_dark_mode : image_background_color || '#000',
        color: isDarkMode && text_color_dark_mode ? text_color_dark_mode : text_color || '#fff',
      }}
    >
      <Image image={image} alt="" gradient absolute />
      <div className={styles.content} datatesting="featuredblock_buttoncontent">
        <h2 className={styles.title}>{heading}</h2>
        <p>{subtext}</p>
        {isExternalButton ? (
          <Button href={button_url} size="large" target="_blank" className={styles.button}>
            {button_text}
          </Button>
        ) : (
          <Button
            size="large"
            onClick={() => handleClick(button_url)}
            to={button_url}
            className={styles.button}
            datatesting="featuredbuttonblockbutton"
          >
            {button_text}
          </Button>
        )}

        {show_skip_button && (
          <div>
            {isExternalSkipButton ? (
              <Link href={skip_button_url} target="_blank" className={styles.skip}>
                {skip_button_text}
              </Link>
            ) : (
              <Link onClick={() => handleClick(button_url)} to={skip_button_url} className={styles.skip}>
                {skip_button_text}
              </Link>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default FeaturedButtonBlock
